import { useContext } from "react";

import { UserContext } from "@/components/User";
import { usePageableQuery } from "@/core/queries";

import { fetchTimeReports } from "../service";

export const useTimeReportsQuery = () => {
  const { contextCompany, contextConsultantProfileId } = useContext(UserContext);

  return usePageableQuery([contextConsultantProfileId, "time-reports"], params =>
    fetchTimeReports({
      ...params,
      companyId: contextCompany?.id,
    }),
  );
};
